import React from 'react';
import { connect } from 'react-redux';

import { _ } from '../../functions/translator.js';

import StatusDropdown from './cardsGroupsDropdown.js';
import StagesDropdown from './stagesDropdown.js';
import LevelDropdown from './levelDropdown.js';
import CategoryDropdown from './categoryDropdown.js';
import ProtocolDropdown from './protocolDropdown.js';
import AnnexesDropdown from './annexesDropdown.js';
import UserSignsDropdown from './userSignsDropdown.js';
import AppartmentDropdown from './appartmentDropdown.js';
import TimelineSwitch from './timelineSwitch.js';
import ChargeSignaturesDropdown from './chargeSignaturesDropdown.js';
import { bindActionCreators } from 'redux';
import { toggleSwitch } from '../../actions/index.js';
import { ToggleActions } from '../../constants/constants.js';
import { FiFilter } from "react-icons/fi";

class OptionsSet extends React.Component {
    setSignaturesFilters = () => {
        this.props.toggleSwitch(ToggleActions.METRICS, false)
        this.props.toggleSwitch(ToggleActions.SIGNATURES_FILTER, !this.props.signaturesFilterSwitch)
    }

    render() {
        return(
            <div>
                <TimelineSwitch/>
                <p className='text'>{ _('Estados Registros') }</p>
                <StatusDropdown/>
                <div className='filters-mobile'>
                    <p className='text'>{ _('Etapas') }</p>
                    <StagesDropdown/>
                    <p className='text'>{ _('Planos') }</p>
                    <LevelDropdown/>
                    <p className='text'>{ _('Categorías') }</p>
                    <CategoryDropdown/>
                    <p className='text'>{ _('Protocolos') }</p>
                    <ProtocolDropdown/>
                    <p className='text'>{ _('Anexos') }</p>
                    <AnnexesDropdown/>
                </div>
                <div className='d-flex flex-row'>
                    <p className='text'>{ _('Firmas por Persona') }</p>
                    <div className='d-flex align-items-center'>
                        <div className='d-flex align-items-center cursor-pointer ml-2' style={{width:'20px', height:'20px'}} onClick={this.setSignaturesFilters}>
                            <FiFilter className='w-100 h-100 text border rounded'/>
                        </div>
                    </div>
                </div>
                <UserSignsDropdown/>
                <div className='d-flex flex-row'>
                    <p className='text'>{ _('Firmas por Cargo') }</p>
                    <div className='d-flex align-items-center'>
                        <div className='d-flex align-items-center cursor-pointer ml-2' style={{width:'20px', height:'20px'}} onClick={this.setSignaturesFilters}>
                            <FiFilter className='w-100 h-100 text border rounded'/>
                        </div>
                    </div>
                </div>
                <ChargeSignaturesDropdown/>
                {this.props.showAppartmentFilter && (
                    <div>
                        <p className='text'>{ _('Departamentos') }</p>
                        <AppartmentDropdown/>
                    </div>
                )}
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        showAppartmentFilter : state.switches.showAppartmentFilter,
        signaturesFilterSwitch : state.switches.signaturesFilter,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(OptionsSet);